module.exports = __webpack_public_path__ + "static/media/blockchainAssets.1c3654a1.png";